module.exports = __webpack_public_path__ + "static/media/homebackground1.733be940.svg";